import getDD365Inventory from './getDD365Inventory';
import getDD365VinDetails from './getDD365VinDetails';

export default { getDD365Inventory, getDD365VinDetails };
